import { retryUnlessRateLimited } from '../utils/queryRetry'
import { useQuery } from '@tanstack/react-query'
import GatingService from '../services/gating'

/**
 * LOT-GATING — état d'essai du tenant courant (GET /api/gating/status).
 *
 * Rafraîchi périodiquement : le bandeau doit annoncer la rupture de quota
 * AVANT que l'agent ne tente d'appeler (la scène téléphonie gelée n'affiche
 * qu'une erreur générique sur refus de token — assumé, poli post-bascule).
 * 60 s de période suffisent : un quota de 5 ne bouge pas plus vite.
 *
 * `enabled` : rien n'est interrogé tant que l'utilisateur n'est pas connu
 * (AppShell ne monte qu'authentifié, mais l'option rend le hook réutilisable).
 */
export function useGatingStatus(enabled: boolean = true) {
  return useQuery({
    queryKey: ['gating', 'status'],
    queryFn: () => GatingService.getStatus(),
    enabled,
    staleTime: 30 * 1000,
    refetchInterval: 60 * 1000,
    retry: retryUnlessRateLimited, // une tentative de plus, jamais sur un 429 (#194, D-G)
  })
}
